import React from 'react';
import { bonuses } from '../../data/content';
import { TransformCTA } from '../TransformCTA';
export function Bonuses() {
  return <section className="w-full bg-white px-4 py-14 sm:py-20" data-id="element-92" data-mp="1hipsh6t2xlou">
      <div className="mx-auto max-w-3xl" data-id="element-93" data-mp="1ckoa6o3h9qef">
        <p className="text-center text-[11px] font-bold uppercase tracking-[0.25em] text-brandred" data-id="element-94" data-mp="1clftp0jsvxoc">
          🎁 Incluidos hoy
        </p>
        <h2 className="mt-3 text-center font-display text-[26px] leading-tight font-black tracking-tight text-navy sm:text-4xl" data-id="element-95" data-mp="259lf7piohqp8">
          5 Bonos Exclusivos incluidos
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-navy/65" data-id="element-96" data-mp="208xqxblu3nyp">
          Porque en el momento crítico no necesitas pensar más… necesitas decidir mejor.
        </p>

        <div className="mt-9 space-y-6" data-id="element-97" data-mp="1rcexly9oxy1l">
          {bonuses.map(b => <article key={b.num} className="overflow-hidden rounded-3xl border border-navy/10 bg-cream" data-id="element-98" data-mp="kvbdle32pwsx">
              <img src={b.image} alt={`${b.num}: ${b.title}`} className="w-full bg-white object-contain" loading="lazy" data-id="element-99" data-mp="1etwttaokogig" />
              <div className="flex items-start gap-3 p-5" data-id="element-100" data-mp="15ti3ty0nyd8m">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-brandred/10 text-lg" data-id="element-101" data-mp="15v2z5pusy07j">
                  <span aria-hidden data-id="element-102" data-mp="w35nkhzvt68a">{b.emoji}</span>
                </span>
                <div className="min-w-0" data-id="element-103" data-mp="w1uf44vhraau">
                  <p className="text-[10px] font-black uppercase tracking-[0.2em] text-brandred" data-id="element-104" data-mp="10ufa39q4vtfy">
                    {b.num}
                  </p>
                  <h3 className="font-display text-[17px] font-black leading-tight tracking-tight text-navy sm:text-xl" data-id="element-105" data-mp="n4buh1lrexzh">
                    {b.title}
                  </h3>
                  <p className="mt-1 text-[13.5px] leading-snug text-navy/65" data-id="element-106" data-mp="d5cjhcdiuq9b">{b.text}</p>
                </div>
              </div>
            </article>)}
        </div>

        <TransformCTA text="Quiero el sistema + los 5 bonos incluidos" data-id="element-107" data-mp="2jt3gg6qumk04" />
      </div>
    </section>;
}